import Cookies from "js-cookie";
import { useContext, useState, useEffect, createContext } from "react";
import http from "../../network/HTTPClient";
const AuthContext = createContext();

const AuthProvider = (props) => {
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    const isLoggedIn = Cookies.get("isLoggedIn") === "true";
    if (isLoggedIn) {
      const token = Cookies.get("token");
      http.defaults.headers.common = { Authorization: `Bearer ${token}` };
    }
    setLoggedIn(isLoggedIn);
  }, []);

  const login = () => {
    Cookies.set("isLoggedIn", true);
    setLoggedIn(true);
    const token = Cookies.get("token");
    http.defaults.headers.common = {
      ...http.defaults.headers.common,
      Authorization: `Bearer ${token}`,
    };
  };

  const logout = () => {
    Cookies.set("isLoggedIn", false);
    Cookies.remove("user");
    Cookies.remove("token");
    setLoggedIn(false);
  };
  const token = () => {
    const token = Cookies.get("token");
    return token;
  };

  const authContextValue = {
    login,
    loggedIn,
    logout,
    token,
  };

  return <AuthContext.Provider value={authContextValue} {...props} />;
};
const useAuth = () => useContext(AuthContext);
export { AuthProvider, useAuth };
